module.exports = __webpack_public_path__ + "img/18_49.9910c0e7.png";